import { Breadcrumbs, Typography, Link, TablePagination } from "@mui/material";
import { Link as LinkTo } from 'react-router';
import { ObrasTopBar } from "../../components/obras_top_bar";
import { ObrasTopHeader } from "../../components/obras_top_header";
import { useObrasDocumentosViewModel } from "../../viewModels/obras_documentos_view_model";
import { StyledDataGrid } from "../Obras_concretagem/components/styled_data_grid";
import { GenerateObraArquivoColumns } from "./columns/obra_arquivo";
import { useMemo } from "react";
import { ObraArquivo } from "../../../domain/models/obra_arquivo";
import { ObraArquivoModal } from "./documents/obra_arquivo_modal";
import { Header } from "./documents/header";

import AlertError from "../../../../../common/components/alert_error";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";

/**
 * ObrasDocumentos
 */

export const ObrasDocumentos = () => {
  const viewModel = useObrasDocumentosViewModel();

  const columns = useMemo(() => {
    return GenerateObraArquivoColumns({
      onActionEditar: viewModel.handleCadastroObraArquivoOpenState,
      onActionDeletar: viewModel.handleDeleteObraArquivoModalOpenState,
      onActionView: viewModel.handleViewObraArquivo,
      onActionDownload: viewModel.handleDownloadObraArquivo,
    });
  }, [
    viewModel.handleCadastroObraArquivoOpenState,
    viewModel.handleDeleteObraArquivoModalOpenState,
    viewModel.handleViewObraArquivo,
    viewModel.handleDownloadObraArquivo,
  ]);

  return (
    <>
      {/**
        * TopBar
        */}

      <ObrasTopBar
        obrasReportState={viewModel.obrasReportState}
        state={viewModel.obrasTopHeaderState}
        selectedObra={viewModel.selectedObraHeaderInfo}
        leftBackSlotButton={
          <div className="flex flex-row gap-2">
            {
              <div>
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  sx={{ px: 2 }}
                  onClick={() => viewModel.handleCadastroObraArquivoOpenState(null, true)}>
                  Novo
                </PrimaryButton>
              </div>
            }
          </div>
        }
        onBack={viewModel.handleBack}
      />

      {/**
        * Content
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-24">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Link underline="hover" color="inherit" component={'span'}>
            <LinkTo to='/Obras_lista'>Lista de Obras</LinkTo>
          </Link>
          <Typography className="text-primary-green">
            Documentos da Obra
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <ObrasTopHeader
            title='Documentos de Obra'
            selectedObra={viewModel.selectedObraHeaderInfo}
            onReload={viewModel.handleReload}
          />
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload}
                />
              </div>
            ) : (
              <>
                <Header
                  status={viewModel.filters.status}
                  situacao={viewModel.filters.situacao}
                  nomeDescricao={viewModel.filters.nomeDescricao}
                  dataVencimento={viewModel.filters.dataVencimento}
                  onStatusChange={viewModel.handleStatusChange}
                  onSituacaoChange={viewModel.handleSituacaoChange}
                  onNomeDescricaoChange={viewModel.handleNomeDescricaoChange}
                  onDataVencimentoChange={viewModel.handleDataVencimentoChange}
                  onClearFilter={viewModel.handleClearFilter}
                />

                <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    rowsPerPageOptions={[100]}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />

                  <StyledDataGrid
                    tableName="obras_informacoes_gerais_5"
                    disableColumnMenu={false}
                    getRowId={(row: ObraArquivo) => row.idObraArquivo}
                    columns={columns}
                    loading={viewModel.loading}
                    height='65vh'
                    rows={viewModel.obraArquivoLista}
                    rowCount={viewModel.obraArquivoLista.length}
                    pageSizeOptions={[100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    rowsPerPageOptions={[100]}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />

                </div>
              </>
            )
        }
      </div>

      {/**
        * Modals
        */}

      <ObraArquivoModal
        open={viewModel.obraArquivoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedObraArquivo={viewModel.selectedObraArquivo ?? null}
        reactHookForm={viewModel.hookForm}
        onClose={() => viewModel.handleCadastroObraArquivoOpenState(null, false)}
        onSubmit={viewModel.handleObraArquivoSubmit}
        onDownload={viewModel.handleDownloadObraArquivo}
      />

      <DeleteDialog
        open={viewModel.obraArquivoDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteObraArquivoModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmObraArquivo}
      />
    </>
  );
}